import z from 'zod';
export const ShortcutId = {
    searchEmployee: 'searchEmployee',
    registerPayment: 'registerPayment',
    registerInvoice: 'registerInvoice',
    stockEntry: 'stockEntry',
    internalTransfer: 'internalTransfer',
    entriesList: 'entriesList',
    bankReconciliation: 'bankReconciliation',
    accountingReports: 'accountingReports',
    createParticipation: 'createParticipation',
};
export const SHORTCUT_IDS = Object.values(ShortcutId);
export const DEFAULT_CONSOLE_SHORTCUTS = [...SHORTCUT_IDS];
export const baseConsoleShortcuts = {
    select: {
        id: true,
        userId: true,
        shortcuts: true,
    },
};
export const ShortcutIdSchema = z.enum(Object.values(ShortcutId));
export const updateConsoleShortcutsSchema = z.object({
    shortcuts: z.array(ShortcutIdSchema),
});
